

export default {
  name: 'PopularizeRecord',
  props: ['promotion']
}
